jQuery(document).ready(function ($) {
    var $header = $('#header');
    var $nav = $('.nav-closed');
    var $menuLinks = $('#menu-primary a[href^="#"]');

    function closeMobileNav() {
        if ($nav.hasClass('open')) {
            $nav.removeClass('open');
            $('.bar1, .bar2, .bar3').removeClass('change');
        }
    }

    function setActiveMenuItem(sectionId) {
        $menuLinks.parent('li').removeClass('active');

        if (!sectionId) {
            return;
        }

        $menuLinks
            .filter('[href="#' + sectionId + '"]')
            .parent('li')
            .addClass('active');
    }

    function updateActiveMenuItem() {
        if (!$menuLinks.length) {
            return;
        }

        var headerHeight = $header.outerHeight() || 0;
        var activationPoint = $(window).scrollTop() + headerHeight + 120;
        var activeSectionId = '';
        var hasValidTargets = false;

        $menuLinks.each(function () {
            var targetSelector = $(this).attr('href');
            var $target = $(targetSelector);

            if ($target.length) {
                hasValidTargets = true;
            }

            if ($target.length && activationPoint >= $target.offset().top) {
                activeSectionId = targetSelector.replace('#', '');
            }
        });

        if (!hasValidTargets) {
            setActiveMenuItem('');
            return;
        }

        if (!activeSectionId) {
            activeSectionId = $menuLinks.first().attr('href').replace('#', '');
        }

        setActiveMenuItem(activeSectionId);
    }

    //burger icon js opens nav and changes burger to cross
    $('body').click(function (e) {
        var target = $(e.target),
            article;

        if (target.is('.mobile-nav-button') || target.is('.bar1') || target.is('.bar2') || target.is('.bar3')) {
            console.log('button')
        } else {

            closeMobileNav();
        }

    });

    $(".mobile-nav-button").click(function () {
        $nav.toggleClass("open");
        $(".bar1").toggleClass("change");
        $(".bar2").toggleClass("change");
        $(".bar3").toggleClass("change");
    });

    $menuLinks.on('click', function () {
        var targetSelector = $(this).attr('href');
        if ($(targetSelector).length) {
            setActiveMenuItem(targetSelector.replace('#', ''));
        }
        closeMobileNav();
    });
    
    //header spacing - disable on homepage so hero can sit behind header
    if ($header.hasClass('homepage')) {
        $('.header-spacing').css('padding-top', '0px');
    } else {
        let headerHeight = $header.outerHeight();
        $('.header-spacing').css('padding-top', `${headerHeight}px`);
    }


    // Check window width and add class to #header for tactile or desktop.
    $(window).on('resize', function () {
        if (window.innerWidth < 992) {
            if (!$header.hasClass('tactile')) {
                $header.addClass('tactile');
                $header.removeClass('desktop');
                console.log("#header.tactile");
            }
        } else {
            if (!$header.hasClass('desktop')) {
                $header.addClass('desktop');
                $header.removeClass('tactile');
                console.log("#header.desktop");
            }
        }
        updateActiveMenuItem();
    }).resize();

    // Toggle header scroll class & floating social sidebar visibility on scroll
    // touchmove/touchend added for iOS Safari which delays scroll events during momentum scroll
    $(window).on('scroll touchmove touchend', function () {
        var scrollTop = window.pageYOffset || $(window).scrollTop();
        var heroHeight = $('#hero-video').outerHeight() || $(window).height();

        if (scrollTop > 50) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }

        if (scrollTop > heroHeight - 80) {
            $('.hero-social-sidebar').addClass('visible');
        } else {
            $('.hero-social-sidebar').removeClass('visible');
        }

        updateActiveMenuItem();
    });

    // Trigger scroll event on load to set initial state
    $(window).trigger('scroll');
})
